module.exports = __webpack_public_path__ + "static/media/exit-modal-flex-plus.e7aff961.png";